import './MenuComponent.scss';
import { Tab, Tabs } from './Tabs/Tabs';

export default function MenuComponent() {
    var menuDetails = [
        {
            "name": "Granola",
            "price": "$14",
            "category": "mains",
            "description": "Homemade granola with yoghurt + berry chia seed compote"
        },
        {
            "name": "Eggs Your Way (V) (GF option)",
            "price": "$12.50",
            "category": "mains",
            "description": "Free range eggs on grilled sourdough/multi grain"
        },
        {
            "name": "Smashed Avo on Sourdough",
            "price": "$18",
            "category": "mains",
            "description": "Avocado w/ sweet chilli sauce, cumin, lemon juice + coriander, topped with caramelized onion, feta + tomato"
        },
        {
            "name": "Eggs Benny (GF Option Hashbrown)",
            "price": "$24",
            "category": "mains",
            "description": "Poached eggs on homemade muffin with ham + hollandaise sauce"
        },
        {
            "name": "Eggs Florrie (GF Option Hashbrown)",
            "price": "$26",
            "category": "mains",
            "description": "Poached eggs with spinach + salmon drizzled with hollandaise served on homemade muffin"
        },
        {
            "name": "Eggs Monty (GF Option Hashbrown)",
            "price": "$24",
            "category": "mains",
            "description": "Poached eggs with spinach + sauteed mushrooms drizzled with hollandaise on homemade muffin"
        },
        {
            "name": "All day Kakariki Feast",
            "price": "$27",
            "category": "mains",
            "description": "Free range eggs, bacon, sausage, mushrooms, hash brown, roasted tomato + smokey beans on toasted sourdough/multi grain"
        },
        {
            "name": "Homemade kimchi and Swiss Cheese Toastie",
            "price": "$18",
            "category": "toasties",
            "description": "Served with potato chips"
        },
        {
            "name": "Ham, Cheese, Tomato Toastie",
            "price": "$16",
            "category": "toasties",
            "description": "Layers of ham, cheese + tomato with potato chips"
        },
        {
            "name": "Cream Corn Toastie",
            "price": "$18",
            "category": "toasties",
            "description": "Sauteed mushrooms + garlic with a combination of spinach, silverbeet + rocket topped with brie with potato chips"
        },
        {
            "name": "Bacon + Jalapeno poppers Toastie",
            "price": "$17",
            "category": "toasties",
            "description": "Crispy bacon, three kinds of cheese and spicy pickled jalapenos served with potato chips"
        },
        {
            "name": "Ham, Cheese + Pineapple Toastie",
            "price": "$16",
            "category": "toasties",
            "description": "Layers of ham, cheese + chargrilled pineapple with potato chips"
        },
        {
            "name": "Fries Steakhouse w/ Aioli + Tomato Ketchup",
            "price": "$12",
            "category": "sides"
        },
        {
            "name": "Kumara Steakhouse w/ Aioli + Tomato Ketchup",
            "price": "$12",
            "category": "sides"
        },
        {
            "name": "Eggs",
            "price": "$4",
            "category": "sides"
        },
        {
            "name": "Ham",
            "price": "$4",
            "category": "sides"
        },
        {
            "name": "Avocado",
            "price": "$4",
            "category": "sides"
        },
        {
            "name": "Hollandaise",
            "price": "$3",
            "category": "sides"
        },
        {
            "name": "Grilled Haloumi",
            "price": "$5",
            "category": "sides"
        },
        {
            "name": "Mushroom",
            "price": "$4",
            "category": "sides"
        },
        {
            "name": "Streaky Bacon",
            "price": "$6",
            "category": "sides"
        },
        {
            "name": "Roasted Tomato",
            "price": "$5",
            "category": "sides"
        },
        {
            "name": "Hashbrown",
            "price": "$4",
            "category": "sides"
        },
        {
            "name": "Smoked Salmon",
            "price": "$7",
            "category": "sides"
        },
        {
            "name": "Kransky Sausage",
            "price": "$5",
            "category": "sides"
        },
        {
            "name": "Smokey Beans",
            "price": "$4",
            "category": "sides"
        },
        {
            "name": "Gluten free bread",
            "price": "$4",
            "category": "sides"
        }
    ];
    const res = Object.groupBy(menuDetails, e => e.category);
    console.log(res);
    var menuArray = [];
    return (
        <section id='menu' className='tw-px-4 md:tw-px-16 menu-component'>
            <h3 className='tw-flex tw-justify-center tw-uppercase section-header'>
                Explore the cuisine
            </h3>
            <Tabs>
                {Object.keys(res).map((innerAttr, index) => {
                    return (
                        <Tab key={index} component={res[innerAttr]}>{innerAttr}</Tab>
                    )
                })}
            </Tabs>
        </section>
    );
}